<template>
	<section class="news-wrap">
		<div class="news-inner">
			<div class="news">
				<div v-for="post in posts" class="post" :key="post.id">
					<p class="date">
						{{ post.created }}
						<a :href="post.categoryUrl" class="cate" :class="post.categoryTag">{{ post.categoryName }}</a>
					</p>
					<p class="newscont">
						<a :href="post.url">
							{{ post.title }}
						</a>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
// const URL_BASE = '/rest/news'; //テストの時
const URL_BASE = 'https://www.mamezou.com/rest/news';
import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
export default {
	name: 'News',
	props: {},
	data() {
		return {
			posts: [],
		};
	},
	methods: {
		getPostsApi: function() {
			axios
				.get(URL_BASE, {
					headers: {
						Authorization: 'Basic cmVzdDpremssWkRDVHB8Xzc=',
					},
				})
				.then((response) => {
					this.posts = [];
					response.data.map((post) => {
						let str = post.category_url;
						let categories = str.split('/').filter((e) => Boolean(e));
						this.posts.push({
							categoryName: post.category_name,
							categoryUrl: post.category_url,
							created: post.created,
							title: post.title,
							url: post.url,
							categoryTag: categories[categories.length - 1],
						});
					});
				});
		},
	},
	mounted: function() {
		this.getPostsApi();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.news-wrap {
	position: relative;
	width: 100%;
	max-width: 920px;
	margin: 0 auto;
	background: repeating-linear-gradient(
		-45deg,
		rgb(69, 69, 69, 0.7) 0,
		rgb(69, 69, 69, 0.7) 2px,
		rgb(12, 12, 12, 0.7) 2px,
		rgb(12, 12, 12, 0.7) 4px
	);
	border-radius: 5px;
	color: #fff;
	font-size: 13px;
	margin-top: -40px;
	margin-bottom: 100px;
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
		margin-top: 30px;
		margin-bottom: 30px;
	}
}
.news-inner {
	margin: 0 auto;
	@media print, screen and (min-width: 1161px) {
		padding: 30px 100px 10px 100px;
	}
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
		padding: 20px 0;
	}
}
.date {
	margin-bottom: 0;
}
.cate {
	background-color: #000;
	margin-left: 20px;
	border-radius: 5px;
	font-size: 12px;
	padding: 2px 15px;
	&.event {
		background-color: #d60000;
	}
	&.techinfo {
		background-color: #005700;
	}
	&.press-release {
		background-color: #0000d6;
	}
	&.news_information {
		background-color: #570057;
	}
}
.newscont {
	margin-top: 0;
	text-decoration: underline;
}
</style>
